import { useParams } from "react-router-dom";
import { Box, Container, Paper, CircularProgress } from "@mui/material";
import { useGetShift } from "@src/containers/ShiftSignoutFlow/api/useGetShift";
import { ShiftTimelinePage } from "../ShiftTimeline/ShiftTimelinePage";
import { Text } from "@src/lib/ui-react";
import { Shift } from "@src/interface";

export function ShiftDetailsPage(): JSX.Element {
  const { shiftId } = useParams<{ shiftId: string }>();

  const { data: shiftData, isLoading, error } = useGetShift(shiftId);

  if (isLoading) {
    return (
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error || !shiftData?.success) {
    return (
      <Container maxWidth="lg">
        <Paper sx={{ p: 3, mt: 4 }}>
          <Text variant="h4" color="error" align="center">
            Error loading shift details
          </Text>
        </Paper>
      </Container>
    );
  }

  return <ShiftTimelinePage shift={shiftData.response as Shift} />;
}
